import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getImage } from '../../Services/Utils/FileApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { getCategories } from '../../Services/Utils/ServiceProviderApis';

function categoriesDropDownList() {
  const dispatch = useDispatch();

  const [listItems, setListItems] = useState();
  useEffect(() => {
    getServiceProviderCategory();
  }, []);

  const getServiceProviderCategory = async () => {
    const params = {
      start: 0,
      recordSize: ''
    };
    await getCategories({ active: true }, params).then(async (responseJson) => {
      const { list, hasError } = responseJson;
      const categoryList = [];
      if (hasError === false) {
        list.forEach((row) => {
          categoryList.push({
            id: row.id,
            text: row.name,
            to: row.keyword,
            path: `${getImage(row.bannerFileView)}`
          });
          setListItems(categoryList);
        });
      } else {
        dispatch(notifySet({
          type: 'error',
          message: 'Category list not found'
        }));
      }
    });
  };
  return listItems;
}

export default categoriesDropDownList;
